import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAcceptedCards = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	fill: "none",
	viewBox: "0 0 224 32",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("path", {
			id: "b",
			fill: "#000",
			d: "M211 467v-28.9c0-11-6.7-18.3-18.3-18.3a19 19 0 0 0-16.4 8.2 17 17 0 0 0-15.4-8.2c-4.9 0-9.7 1.5-13.5 6.7v-5.8h-10.1V467h10v-25.5c0-8.2 4.4-12.1 11.2-12.1 6.7 0 10 4.3 10 12V467h10.2v-25.5c0-8.2 4.8-12.1 11-12.1 6.8 0 10.2 4.3 10.2 12V467H211Zm150-46.3h-16.3v-14h-10.2v14h-9.1v9.2h9.1v21.2c0 10.7 4.4 16.9 16 16.9 4.3 0 9.1-1.5 12.5-3.4l-3-8.7c-2.9 2-6.2 2.4-8.7 2.4-4.8 0-6.7-2.9-6.7-7.7V430H361v-9.2Zm86-1a14 14 0 0 0-12.2 6.8v-5.8h-10V467h10v-26c0-7.8 3.4-12.2 9.7-12.2 2 0 4.3.5 6.3 1l3-9.7c-2.1-.4-5-.4-6.9-.4Zm-129.8 4.9a33.2 33.2 0 0 0-18.8-4.9c-11.6 0-19.3 5.8-19.3 15 0 7.7 5.8 12 15.9 13.5l4.8.5c5.3 1 8.2 2.4 8.2 4.8 0 3.4-3.8 5.8-10.6 5.8-6.7 0-12-2.4-15.4-4.8l-4.9 7.7a33.9 33.9 0 0 0 19.8 5.7c13.5 0 21.2-6.2 21.2-14.9 0-8.2-6.3-12.5-15.9-14l-4.8-.5c-4.3-.5-7.7-1.5-7.7-4.3 0-3.4 3.4-5.3 8.7-5.3a34 34 0 0 1 14.5 3.9l4.3-8.2Zm269-4.9c-5.7 0-9.6 3-12 6.8v-5.8H564V467h10v-26c0-7.8 3.5-12.2 9.7-12.2 2 0 4.4.5 6.3 1l3-9.6c-2-.5-4.9-.5-6.8-.5ZM457 444c0 14 9.7 24.1 24.6 24.1 6.8 0 11.6-1.5 16.4-5.3l-4.8-8.2c-3.9 3-7.7 4.3-12 4.3-8.3 0-14-5.7-14-14.9 0-8.7 5.7-14.5 14-15 4.3 0 8.1 1.5 12 4.4l4.8-8.2a24 24 0 0 0-16.4-5.3c-14.9 0-24.6 10.1-24.6 24.1Zm93.6 0v-23.2h-10.1v5.8a17.5 17.5 0 0 0-14.5-6.7c-13 0-23.2 10.1-23.2 24.1 0 14 10.1 24.1 23.2 24.1 6.7 0 11.5-2.4 14.5-6.7v5.7h10V444Zm-37.2 0c0-8.2 5.3-15 14-15 8.2 0 14 6.3 14 15 0 8.2-5.8 15-14 15-8.6-.6-14-6.9-14-15Zm-121-24.2c-13.5 0-23.1 9.7-23.1 24.1 0 14.5 9.6 24.1 23.6 24.1 6.8 0 13.5-1.9 18.8-6.2l-4.8-7.3a23 23 0 0 1-13.5 4.8c-6.3 0-12.5-2.9-14-11h34.3v-4c.4-14.8-8.3-24.5-21.3-24.5Zm0 8.7c6.3 0 10.6 4 11.6 11.1h-24.1c1-6.2 5.3-11 12.5-11ZM643.7 444v-41.5h-10.1v24.1a17.5 17.5 0 0 0-14.5-6.7c-13 0-23.2 10.1-23.2 24.1 0 14 10.1 24.1 23.2 24.1 6.7 0 11.5-2.4 14.5-6.7v5.7h10V444Zm-37.2 0c0-8.2 5.3-15 14-15 8.2 0 14 6.3 14 15 0 8.2-5.8 15-14 15-8.7-.6-14-6.9-14-15ZM268 444v-23.2h-10.1v5.8a17.5 17.5 0 0 0-14.5-6.7c-13 0-23.2 10.1-23.2 24.1 0 14 10.1 24.1 23.2 24.1 6.7 0 11.5-2.4 14.5-6.7v5.7h10V444Zm-37.6 0c0-8.2 5.3-15 14-15 8.2 0 14 6.3 14 15 0 8.2-5.8 15-14 15-8.7-.6-14-6.9-14-15Z"
		}) }),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("pattern", {
				id: "d",
				width: 1,
				height: 1,
				patternContentUnits: "objectBoundingBox",
				children: /* @__PURE__ */ _jsx("use", {
					xlinkHref: "#a",
					transform: "matrix(.00195 0 0 .00488 0 -.8)"
				})
			}),
			/* @__PURE__ */ _jsx("pattern", {
				id: "f",
				width: 1,
				height: 1,
				patternContentUnits: "objectBoundingBox",
				children: /* @__PURE__ */ _jsx("use", {
					xlinkHref: "#b",
					transform: "matrix(.00195 0 0 .00488 0 -.8)"
				})
			}),
			/* @__PURE__ */ _jsx("pattern", {
				id: "h",
				width: 1,
				height: 1,
				patternContentUnits: "objectBoundingBox",
				children: /* @__PURE__ */ _jsx("use", {
					xlinkHref: "#k",
					transform: "matrix(.00195 0 0 .00488 0 -.7)"
				})
			}),
			/* @__PURE__ */ _jsx("pattern", {
				id: "j",
				width: 1,
				height: 1,
				patternContentUnits: "objectBoundingBox",
				children: /* @__PURE__ */ _jsx("use", {
					xlinkHref: "#l",
					transform: "matrix(.00457 0 0 .00685 0 -.1)"
				})
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "c",
				width: 59,
				height: 32,
				x: 0,
				y: 0,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						result: "hardAlpha",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" }),
					/* @__PURE__ */ _jsx("feBlend", {
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_1952:11083"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "effect1_dropShadow_1952:11083",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "e",
				width: 59,
				height: 32,
				x: 55,
				y: 0,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						result: "hardAlpha",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" }),
					/* @__PURE__ */ _jsx("feBlend", {
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_1952:11083"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "effect1_dropShadow_1952:11083",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "g",
				width: 59,
				height: 32,
				x: 110,
				y: 0,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						result: "hardAlpha",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" }),
					/* @__PURE__ */ _jsx("feBlend", {
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_1952:11083"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "effect1_dropShadow_1952:11083",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "i",
				width: 59,
				height: 32,
				x: 165,
				y: 0,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						result: "hardAlpha",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" }),
					/* @__PURE__ */ _jsx("feBlend", {
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_1952:11083"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "effect1_dropShadow_1952:11083",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "a",
				children: /* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "M0 0h780v500H0z"
				})
			})
		] }),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#c)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					width: 51,
					height: 24,
					x: 4,
					y: 2,
					fill: "#fff",
					rx: 1
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "url(#d)",
					d: "M7 5h45v18H7z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#2fabf7",
					d: "M11.3 10.8h1.5l-.7-2-.8 2Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#228fe0",
					d: "M29.7 9.1h-1.9v1h1.9l.2-.5c0-.3 0-.4-.2-.5Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#0571c1",
					d: "M44.1 7.1V8l-.4-.8h-3.2V8l-.4-.8h-4.3c-.7 0-1.3.2-1.9.4v-.4h-3v.4a2 2 0 0 0-1.3-.4H18.8l-.7 1.7-.8-1.7H14V8l-.4-.8h-3l-1.3 3.2-1.5 3.5h3.4l.4-1h1l.4 1h3.9V13l.3.8h2l.3-.8v.8h9.4V12h.1l.1.2v1.5H34v-.4a4 4 0 0 0 1.8.4h2l.4-1h1l.4 1h3.9v-1l.6 1H47V7.1h-3Zm-22.7 5.7h-1.2V9l-1.6 3.7h-1L16 9v3.7h-2.3l-.5-1H11l-.4 1H9.2l2-4.7H13l2 4.5V8h1.7l1.5 3.2L19.5 8h1.9v4.7ZM25.9 9h-2.6v.8H26v1h-2.6v1H26v1h-3.7V8H26v1Zm5 2a1.7 1.7 0 0 1 .3.8v1H30v-.7c0-.2 0-.6-.2-1L29 11h-1.2v1.7h-1.1V8.1h2.5c.6 0 1 0 1.4.2s.5.5.5 1a1.3 1.3 0 0 1-.8 1.3c.3 0 .5.3.7.4Zm2.1 1.7h-1.1V8H33v4.8Zm13.3 0h-1.7l-2.1-3.6v3.6h-2.3l-.4-1h-2.4l-.4 1h-1.2c-.6 0-1.2 0-1.7-.5-.4-.4-.6-1-.6-1.8 0-.7.2-1.4.6-1.9.4-.4 1-.5 1.7-.5H37v1h-1c-.5 0-.7 0-1 .2-.1.2-.3.6-.3 1.1 0 .6 0 .9.4 1.2.2.2.4.2.8.2h.4L37.9 8h1.7l1.8 4.5V8.1H43l2 3.3V8.1h1v4.7h.2Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#228fe0",
					d: "M37.8 10.8h1.6l-.7-2-.9 2Zm-11.4 9.6v-3.8l-1.7 1.9 1.7 2Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#2fabf7",
					d: "M19.2 17v1h2.5v.9h-2.5v1H22l1.2-1.4-1.2-1.4h-2.8Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#228fe0",
					d: "M29 17h-1.4v1.3H29c.4 0 .7-.2.7-.6 0-.4-.3-.6-.7-.6Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#0571c1",
					d: "M49.8 18.2v-3h-2.9c-.6 0-1 .1-1.4.4v-.4h-3c-.5 0-1.2.1-1.4.4v-.4h-5.5v.4c-.4-.3-1.1-.4-1.5-.4h-3.6v.4c-.3-.3-1.1-.4-1.5-.4h-4l-1 1-.9-1h-6v6.6H23l1-1 .8 1h3.6v-1.6h.5c.5 0 1 0 1.5-.2v2h3v-2h.2c.2 0 .2 0 .2.2V22H43a3 3 0 0 0 1.5-.4v.4h3a3 3 0 0 0 1.5-.4c.7-.4 1.1-1.1 1.1-2 0-.5-.1-1-.3-1.3Zm-20.9 1.1h-1.3v1.6h-2.2l-1.3-1.5-1.5 1.5h-4.4v-4.8h4.5l1.4 1.6 1.4-1.6H29c1 0 2 .3 2 1.6-.2 1.3-1 1.6-2.1 1.6Zm6.7-.3c.2.2.2.5.2 1v.9h-1.1v-.7c0-.2 0-.7-.2-.9-.2-.2-.4-.2-.8-.2h-1.2v1.8h-1.2V16H34c.5 0 1 0 1.3.2s.6.5.6 1a1.3 1.3 0 0 1-.8 1.3l.6.4Zm4.7-2h-2.7v1h2.6v.9h-2.6v1h2.7v1h-3.8V16h3.8v1Zm2.7 4h-2.2v-1H43c.2 0 .3 0 .5-.2l.1-.3-.1-.4-.4-.1c-1.1 0-2.4 0-2.4-1.5 0-.7.4-1.4 1.6-1.4h2.2v1.2H42l-.1.4c0 .2 0 .2.2.3h1c.6 0 1 .2 1.3.5.2.2.3.5.3 1 0 1-.6 1.5-1.7 1.5Zm5.8-.5c-.3.2-.8.5-1.4.5h-2.2v-1h2.2c.2 0 .3 0 .4-.2l.2-.3c0-.1 0-.3-.2-.4l-.4-.1c-1 0-2.3 0-2.3-1.5 0-.7.4-1.4 1.6-1.4H49v1.2h-2.5l-.1.4c0 .2 0 .2.3.3h1c.6 0 1 .2 1.3.5.2.3.3.6.3 1s-.1.7-.4 1Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#228fe0",
					d: "M34.4 17.2h-1.9v1h1.9c.2-.1.2-.3.2-.5 0-.3 0-.4-.2-.5Zm-4.7-8-.5-.1h-1.4v1h1.9l.2-.5c0-.3 0-.4-.2-.5Zm8.1 1.6h1.6l-.7-2-.9 2Zm-11.4 9.6v-3.8l-1.7 1.9 1.7 2Zm2.6-3.3h-1.4v1.2H29c.4 0 .7-.2.7-.6 0-.4-.3-.6-.7-.6Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#228fe0",
					d: "M34.4 17.2h-1.9v1h1.9c.2-.1.2-.3.2-.5 0-.3 0-.4-.2-.5Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#2fabf7",
					d: "m28.5 20.7-1-1V21h-2.2L24 19.3l-1.5 1.6h-4.4V16h4.5l1.4 1.6.7-.8-1.7-1.7h-6v6.6h6l1-1 .9 1h3.6v-1Zm-7-7-.9-1h-.4v-.3l-1-1-.7 1.4h-1L16 9v3.7h-2.3l-.5-1H11l-.4 1H9.2l2-4.7H13l2 4.5V8h1l-1-1h-1v1l-.3-.8h-3l-1.4 3.2-1.5 3.4h3.5l.4-1h1l.4 1h3.8V13l.3.8h2l.3-.8v.8h2Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#2fabf7",
					d: "m18.4 10.6-1-1 .7 1.7.3-.7Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#228fe0",
					d: "M49 21.5c.6-.4 1-1.1 1.1-1.9l-1-.9.2.7c0 .4-.1.7-.4 1-.3.2-.8.5-1.4.5h-2.2v-1h2.2c.2 0 .3 0 .4-.2l.2-.3c0-.1 0-.3-.2-.4l-.4-.1c-1 0-2.3 0-2.3-1.5 0-.7.4-1.3 1.4-1.4l-.7-.7-.3.1V15h-3.1c-.5 0-1 .1-1.4.4V15h-5.5v.4c-.4-.3-1.1-.4-1.5-.4h-3.6v.4c-.3-.3-1.1-.4-1.5-.4h-4l-1 1-.9-1h-.7l2 2 1-1H29c.8 0 1.8.2 1.8 1.5S30 19 29 19h-1.3v1l1 1v-1h.3c.5 0 1 0 1.5-.2v1.8h3V20h.2c.2 0 .2 0 .2.2v1.5H43c.6 0 1.2-.1 1.5-.4v.4h3c.4 0 1 0 1.5-.2ZM35.6 19c.2.2.2.5.2 1v.9h-1.1v-.7c0-.2 0-.7-.2-.9-.2-.2-.4-.2-.8-.2h-1.2v1.8h-1.2V16H34c.5 0 1 0 1.3.2s.6.5.6 1a1.3 1.3 0 0 1-.8 1.3l.6.4Zm4.7-2h-2.7v1h2.6v.9h-2.6v1h2.7v1h-3.8V16h3.8v1Zm2.7 4h-2.2v-1H43c.2 0 .3 0 .5-.2l.1-.3-.1-.4-.4-.1c-1.1 0-2.4 0-2.4-1.5 0-.7.4-1.4 1.6-1.4h2.2v1.2H42l-.1.4c0 .2 0 .2.2.3h1c.6 0 1 .2 1.3.5.2.2.3.5.3 1 0 1-.6 1.5-1.7 1.5Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#228fe0",
					d: "M46.3 17.6c0 .2.1.2.3.3h1c.4 0 .7.1 1 .3l-1-1h-1.1l-.2.4Zm-2.3-4 .1.1-.1-.2Zm-3.7-3.8 1.1 2.8V11l-1.1-1.2Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#228fe0",
					d: "M28.8 12h.1l.1.2v1.5h5v-.4a4 4 0 0 0 1.8.4h2l.4-1h1l.4 1h3.9V13l-1-.9v.7h-2.3l-.3-1h-2.4l-.4 1h-1.2c-.6 0-1.2 0-1.7-.5-.4-.4-.6-1-.6-1.8 0-.7.2-1.4.6-1.9.4-.4 1-.5 1.7-.5H37v1h-1c-.5 0-.7 0-1 .2-.1.2-.3.6-.3 1.1 0 .6 0 .9.4 1.2.2.2.4.2.8.2h.4l1.6-3.7h.7l-1-1h-1.7c-.8 0-1.4.2-2 .5v-.4H31v.4a2 2 0 0 0-1.3-.4H18.8l-.7 1.7-.8-1.7h-3l1 1h1.3l1.2 2.4.4.4 1.2-3h1.9v4.8H20V9.1l-1 2.7 2 2h7.7V12Zm3-4H33v4.8h-1.1V8.1ZM26 9h-2.6v1H26v.9h-2.6v1H26v1h-3.7V8H26v1Zm2 3.8h-1.2V8h2.5c.6 0 1 0 1.4.2s.5.5.5 1a1.3 1.3 0 0 1-.8 1.4c.3 0 .5.2.5.4a1.7 1.7 0 0 1 .3.8v1H30v-.6c0-.3 0-.7-.2-1l-.7-.1h-1.2v1.7Z"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#e)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					width: 51,
					height: 24,
					x: 59,
					y: 2,
					fill: "#fff",
					rx: 1
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "url(#f)",
					d: "M62 5h45v18H62z"
				}),
				/* @__PURE__ */ _jsxs("g", {
					transform: "translate(61.3 -8.8) scale(.7242)",
					children: [
						/* @__PURE__ */ _jsx("circle", {
							cx: 33.9,
							cy: 27.4,
							r: 5.2,
							fill: "#EF9122"
						}),
						/* @__PURE__ */ _jsx("path", {
							fill: "#F26E21",
							d: "M28.7 27.4c0-2.9 2.3-5.2 5.2-5.2 2.9 0 5.2 2.3 5.2 5.2 0 2.9-2.3 5.2-5.2 5.2"
						}),
						/* @__PURE__ */ _jsx("path", {
							fill: "#F44500",
							d: "M30.3 23.7c2-2 5.3-2 7.3 0s2 5.3 0 7.3"
						}),
						/* @__PURE__ */ _jsx("path", {
							fill: "#595A5B",
							d: "M3.8 22.5H1v9.8h2.8c1.5 0 2.6-.4 3.5-1.1a5 5 0 0 0 1.8-3.8c0-2.9-2.1-4.9-5.3-4.9zm2.3 7.4c-.6.5-1.4.8-2.6.8h-.6v-6.5h.5c1.2 0 2 .2 2.6.8.7.6 1.1 1.5 1.1 2.4a3 3 0 0 1-1 2.5zm3.9-7.4h1.9v9.8H10zm6.7 3.8c-1.2-.4-1.5-.7-1.5-1.2 0-.6.6-1.1 1.4-1.1.6 0 1.1.2 1.6.8l1-1.3a4.4 4.4 0 0 0-2.9-1.1c-1.7 0-3.1 1.2-3.1 2.8 0 1.4.6 2 2.4 2.7l1.3.6c.4.2.6.6.6 1 0 .8-.6 1.4-1.5 1.4s-1.7-.5-2.1-1.3l-1.2 1.2c.9 1.3 2 1.9 3.4 1.9 2 0 3.4-1.3 3.4-3.2 0-1.7-.6-2.4-2.8-3.2z"
						}),
						/* @__PURE__ */ _jsx("path", {
							fill: "#3B3D3F",
							d: "M20.1 27.4a5 5 0 0 0 5.2 5.1c.8 0 1.5-.2 2.4-.6v-2.3c-.8.8-1.5 1.1-2.3 1.1-1.9 0-3.3-1.4-3.3-3.4 0-1.9 1.4-3.4 3.2-3.4.9 0 1.6.3 2.4 1.1v-2.3a5 5 0 0 0-2.4-.6c-2.8.2-5.2 2.5-5.2 5.3z"
						}),
						/* @__PURE__ */ _jsx("path", {
							fill: "#000",
							d: "m43.4 29.1-2.6-6.6h-2.1l4.1 10.1h1.1l4.3-10.1h-2.1zm5.6 3.2h5.5v-1.6H51V28h3.4v-1.7H51v-2.1h3.5v-1.7H49z"
						}),
						/* @__PURE__ */ _jsx("path", {
							fill: "#595A5B",
							d: "M59.9 28.2c1.5-.3 2.3-1.3 2.3-2.8 0-1.8-1.3-2.9-3.5-2.9h-2.9v9.8h1.9v-3.9h.3l2.7 3.9H63l-3.1-4.1zM58.3 27h-.6v-3h.6c1.2 0 1.9.5 1.9 1.5s-.7 1.5-1.9 1.5zM3.8 22.5H1v9.8h2.8c1.5 0 2.6-.4 3.5-1.1a5 5 0 0 0 1.8-3.8c0-2.9-2.1-4.9-5.3-4.9zm2.3 7.4c-.6.5-1.4.8-2.6.8h-.6v-6.5h.5c1.2 0 2 .2 2.6.8.7.6 1.1 1.5 1.1 2.4a3 3 0 0 1-1 2.5zm3.9-7.4h1.9v9.8H10zm6.7 3.8c-1.2-.4-1.5-.7-1.5-1.2 0-.6.6-1.1 1.4-1.1.6 0 1.1.2 1.6.8l1-1.3a4.4 4.4 0 0 0-2.9-1.1c-1.7 0-3.1 1.2-3.1 2.8 0 1.4.6 2 2.4 2.7l1.3.6c.4.2.6.6.6 1 0 .8-.6 1.4-1.5 1.4s-1.7-.5-2.1-1.3l-1.2 1.2c.9 1.3 2 1.9 3.4 1.9 2 0 3.4-1.3 3.4-3.2 0-1.7-.6-2.4-2.8-3.2zm8.7 6.2c.8 0 1.5-.2 2.4-.6v-2.3c-.8.8-1.5 1.1-2.3 1.1-1.9 0-3.3-1.4-3.3-3.4 0-1 .4-1.8 1-2.5l-1.3-1.3c-1 .9-1.7 2.3-1.7 3.8-.1 3 2.2 5.2 5.2 5.2z"
						}),
						/* @__PURE__ */ _jsx("path", {
							fill: "#000",
							d: "M59.9 28.2c1.5-.3 2.3-1.3 2.3-2.8 0-1.8-1.3-2.9-3.5-2.9h-2.9v9.8h1.9v-3.9h.3l2.7 3.9H63l-3.1-4.1zM58.3 27h-.6v-3h.6c1.2 0 1.9.5 1.9 1.5s-.7 1.5-1.9 1.5z"
						}),
						/* @__PURE__ */ _jsx("path", {
							fill: "#F26E21",
							d: "M15.1 41.4v-5.5l3.8 3.9v-3.6h.8v5.5l-3.8-3.9v3.6h-.8zm8.6-4.4h-2.1v1.2h2v.8h-2v1.7h2.1v.7h-2.9v-5.2h2.9v.8zm2.5 0v4.4h-.8V37h-1.2v-.7h3.2v.7h-1.2zm2.4-.7 1.3 3.5 1.4-3.7 1.3 3.7 1.4-3.5h1l-2.3 5.5-1.3-3.7-1.4 3.7-2.2-5.5h.8zm6.5 2.5a2.7 2.7 0 0 1 2.7-2.7 2.7 2.7 0 0 1 2.7 2.7 2.7 2.7 0 0 1-2.7 2.7c-.7 0-1.3-.2-1.8-.7-.6-.5-.9-1.1-.9-2zm.8 0c0 .6.2 1 .6 1.4.4.4.8.6 1.3.6s1-.2 1.4-.6c.4-.4.6-.8.6-1.4 0-.6-.2-1-.6-1.4-.4-.4-.8-.6-1.4-.6a2 2 0 0 0-1.4.6c-.3.4-.5.9-.5 1.4zm7.4.4 1.6 2.2h-1l-1.5-2.1h-.1v2.1h-.8v-5.2h.9c.7 0 1.2.1 1.5.4.3.3.5.7.5 1.1 0 .4-.1.7-.3.9-.2.4-.5.6-.8.6zm-1-.6h.2c.7 0 1.1-.3 1.1-.8s-.4-.8-1.1-.8h-.3v1.6zm4.1-.3 2-2.1h1l-2.3 2.3 2.3 2.8h-1L46.5 39l-.2.2v2.1h-.8v-5.2h.8v2.2z"
						}),
						/* @__PURE__ */ _jsx("path", {
							fill: "#3B3D3F",
							d: "M52.8 30.7H51v-1.8l-2-2v5.4h5.4zm-7.2-7.2-2.2 5.6-2.6-6.6h-2.1l4.1 10.1h1.1l3.2-7.6z"
						})
					]
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#g)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					width: 51,
					height: 24,
					x: 114,
					y: 2,
					fill: "#fff",
					rx: 1
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "url(#h)",
					d: "M117 5h45v18h-45z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#3C58BF",
					d: "m132.7 20.8 2.2-12.7h3.6l-2.2 12.7h-3.6Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#293688",
					d: "m132.7 20.8 2.8-12.7h3l-2.2 12.7h-3.6Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#3C58BF",
					d: "M149 8.2a9 9 0 0 0-3.2-.5c-3.5 0-6 1.7-6 4.3 0 2 1.7 2.9 3.1 3.5 1.4.7 1.8 1 1.8 1.7 0 .8-1 1.2-2 1.2-1.5 0-2.3-.2-3.5-.7l-.5-.2-.5 3c.9.3 2.4.6 4 .6 3.8 0 6.3-1.7 6.3-4.4 0-1.5-1-2.7-3-3.6-1.3-.6-2.2-1-2.2-1.6 0-.6.7-1.1 2.2-1.1 1.2 0 2 .2 2.6.5l.4.1.6-2.8Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#293688",
					d: "M149 8.2a9 9 0 0 0-3.2-.5c-3.5 0-5.4 1.7-5.4 4.3 0 2 1.1 2.9 2.5 3.5 1.4.7 1.8 1 1.8 1.7 0 .8-1 1.2-2 1.2-1.5 0-2.3-.2-3.5-.7l-.5-.2-.5 3c.9.3 2.4.6 4 .6 3.8 0 6.3-1.7 6.3-4.4 0-1.5-1-2.7-3-3.6-1.3-.6-2.2-1-2.2-1.6 0-.6.7-1.1 2.2-1.1 1.2 0 2 .2 2.6.5l.4.1.6-2.8Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#3C58BF",
					d: "M155.1 8.1c-.8 0-1.4 0-1.8 1L148 20.7h3.8l.7-2h4.6l.4 2h3.4l-3-12.7h-2.8Zm-1.6 8.5 1.4-3.8.5-1.2.2 1.2.9 3.9h-3v-.1Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#293688",
					d: "M156 8.1c-.9 0-1.5 0-1.8 1L148 20.7h3.8l.7-2h4.6l.4 2h3.4l-3-12.7H156Zm-2.5 8.5 1.4-3.8.5-1.2.2 1.2.9 3.9h-3v-.1Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#3C58BF",
					d: "m126.1 17-.3-1.8c-.7-2.1-2.7-4.5-5-5.6l3.2 11.3h3.8l5.7-12.7h-3.7L126 17Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#293688",
					d: "m126.1 17-.3-1.8c-.7-2.1-2.7-4.5-5-5.6l3.2 11.3h3.8l5.7-12.7h-3L126 17Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#FFBC00",
					d: "m116.3 8.1.6.1c4.6 1.1 7.7 3.8 8.9 7l-1.4-6c-.2-.9-.8-1-1.6-1h-6.6Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#F7981D",
					d: "M116.3 8.1c4.5 1 8.3 3.8 9.5 7l-1.2-5c-.2-.8-1-1.4-1.7-1.4l-6.6-.6Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#ED7C00",
					d: "M116.3 8.1c4.5 1 8.3 3.8 9.5 7l-.9-2.8c-.2-.8-.5-1.6-1.4-2l-7.2-2.2Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#051244",
					d: "m129.7 16.6-2.4-2.4-1.2 2.7-.2-1.8c-.7-2.1-2.7-4.4-5-5.6l3.2 11.3h3.8l1.8-4.2Zm6.6 4.2-3-3-.6 3h3.5Zm8.1-4.3c.3.2.4.4.3.7 0 .9-1 1.3-2 1.3-1.5 0-2.3-.2-3.5-.7l-.5-.2-.5 2.9c.9.3 2.4.7 4 .7 2.3 0 4.2-.6 5.2-1.8l-3-3Zm4.1 4.3h3.3l.7-2h4.6l.4 2h3.4l-1.2-5.1-4.3-4.1.2 1.1.9 3.9h-3l1.4-3.8.5-1.2"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#i)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					width: 51,
					height: 24,
					x: 169,
					y: 2,
					fill: "#fff",
					rx: 1
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "url(#j)",
					d: "M181 5h27v18h-27z"
				}),
				/* @__PURE__ */ _jsxs("g", {
					clipPath: "url(#a)",
					transform: "translate(178.6 4) scale(.04004)",
					children: [
						/* @__PURE__ */ _jsx("path", { d: "M780 0H0v500h780V0Z" }),
						/* @__PURE__ */ _jsx("use", { xlinkHref: "#b" }),
						/* @__PURE__ */ _jsx("use", { xlinkHref: "#b" }),
						/* @__PURE__ */ _jsx("path", {
							fill: "#FF5A00",
							d: "M465.7 69.1H313.8v273h152V69Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							fill: "#EB001B",
							d: "M324 205.6c0-55.4 26-104.7 66-136.5a173.5 173.5 0 1 0 0 273c-40-31.4-66-81-66-136.5Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							fill: "#F79E1B",
							d: "M670.7 205.6A173.5 173.5 0 0 1 390 342.1a174.1 174.1 0 0 0 0-273A172.4 172.4 0 0 1 497 32a174 174 0 0 1 173.7 173.6Z"
						})
					]
				})
			]
		})
	]
});
export default SvgAcceptedCards;
